export const comments_5588474 = {"data":{"data":[],"links":{}}}